import { defaultApiState } from '@/store/types/general.types';
import { TrainerState } from './trainer.types';

export const trainerState: TrainerState = {
  apiState: {
    getTrainers: defaultApiState,
    getPaginatedTrainers: defaultApiState
  },
  trainers: undefined,
  paginatedTrainers: undefined
};
